/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WebContentFullResponse } from '../../models/web-content-full-response';

export interface GetWebContent$Params {
  id: string;
}

export function getWebContent(http: HttpClient, rootUrl: string, params: GetWebContent$Params, context?: HttpContext): Observable<StrictHttpResponse<WebContentFullResponse>> {
  const rb = new RequestBuilder(rootUrl, getWebContent.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {"style":"simple"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WebContentFullResponse>;
    })
  );
}

getWebContent.PATH = '/v0/web-contents/{id}';
